import { type RefObject, useEffect } from 'react';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

import type { Article } from 'app/modules/wallforming/components/scenes/objects/articles/types/article';
import type { Poi } from 'app/modules/wallforming/components/scenes/objects/pois/types/poi';

interface PanelPlacementSubscriptionProps {
    selectedPoiIndexRef: RefObject<number | undefined>;
    poisRef: RefObject<Poi[] | undefined>;
    articlesRef: RefObject<Record<string, Article>>;
    updateActionIcon: () => void;
}

export const usePanelPlacementSubscriptions = ({
    selectedPoiIndexRef,
    poisRef,
    articlesRef,
    updateActionIcon
}: PanelPlacementSubscriptionProps) => {

    useEffect(() => {
        const subscribedPois = usePlacementStore.subscribe(
            (state) => state.pois,
            (newPois) => {
                poisRef.current = newPois;
                updateActionIcon();
            }
        );

        return () => {
            subscribedPois();
        };
    }, [articlesRef, poisRef, selectedPoiIndexRef, updateActionIcon]);

    useEffect(() => {
        const subscribedSelectedPoiIndex = usePlacementStore.subscribe(
            (state) => state.poiSelection.current.index,
            (newPoiIndex) => {
                selectedPoiIndexRef.current = newPoiIndex;
                updateActionIcon();
            }
        );

        return () => {
            subscribedSelectedPoiIndex();
        };
    }, [articlesRef, poisRef, selectedPoiIndexRef, updateActionIcon]);

    useEffect(() => {
        const subscribedArticles = usePlacementStore.subscribe(
            (state) => state.articles,
            (newArticles) => {
                articlesRef.current = newArticles;
            }
        );

        return () => {
            subscribedArticles();
        };
    }, [articlesRef]);
};
